module.exports = __webpack_public_path__ + "static/media/movein.7dc9d745.png";